import { render } from "./TourEditErrorModal.vue?vue&type=template&id=6f63940a&ts=true"
import script from "./TourEditErrorModal.vue?vue&type=script&lang=ts"
export * from "./TourEditErrorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__